/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC } from 'react';
import { Delete, InsertDriveFile } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import { downloadFileLocally, formatFileSize } from './DropzoneBox.utils';

interface IDropzoneBoxFileProps {
    id: number;
    file: File;
    onDeleteFile?: (file: File) => void;
    onDownloadFile?: () => void;
    disableDownload?: boolean;
    disableFileStatus?: boolean;
}

export const DropzoneBoxFile: FC<IDropzoneBoxFileProps> = ({
    id,
    file,
    onDeleteFile,
    onDownloadFile,
    disableDownload,
    disableFileStatus,
}) => {
    const handleDownload = async () => {
        if (onDownloadFile) {
            onDownloadFile();
        }

        downloadFileLocally(file);
    };

    const handleDelete = () => {
        if (onDeleteFile) {
            onDeleteFile(file);
        }
    };

    // TODO: support more file statuses?
    const fileStatus = () => {
        return 'ready to upload';
    };

    return (
        <Stack
            data-testid={`file-${id}`}
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            width={'100%'}
            sx={{
                borderBottom: (theme) => `1px solid ${theme.palette.grey[400]}`,
            }}
        >
            <Stack flexDirection="row" alignItems="flex-start" justifyContent="flex-start">
                <InsertDriveFile />
                <Stack flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                    <Typography>{disableDownload ? file.name : <a onClick={handleDownload}>{file.name}</a>}</Typography>
                    {file.size && (
                        <Typography
                            fontSize={'11px'}
                            sx={{ color: (theme) => theme.palette.grey[700] }}
                        >{`(${formatFileSize(file.size)})`}</Typography>
                    )}
                    {!disableFileStatus && (
                        <Typography variant={'caption'} sx={{ color: (theme) => theme.palette.grey[700] }}>
                            {fileStatus()}
                        </Typography>
                    )}
                </Stack>
            </Stack>
            {/* <p className="file-size">{FileSize || ''}</p> */}
            {onDeleteFile && (
                <IconButton aria-label={`Remove ${file.name}`} onClick={handleDelete}>
                    <Delete />
                </IconButton>
            )}
        </Stack>
    );
};
